/**
 * @fileoverview PUT handler for the "/apps/user_info/:user_identifier/change_email" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUserIdentifierChangeEmailCacheKeys } from "./constants";
import type {
  PutAppsUserInfoUserIdentifierChangeEmailProps,
  AppsUserInfoUserIdentifierChangeEmailResult,
} from "./types";

export const putAppsUserInfoUserIdentifierChangeEmail = reactQueryMutationAdapter(
  appsUserInfoUserIdentifierChangeEmailCacheKeys,
  ({
    userId,
    appGroupId,
    newEmailAddress,
  }: PutAppsUserInfoUserIdentifierChangeEmailProps): Promise<AppsUserInfoUserIdentifierChangeEmailResult> => {
    return fetch(`/apps/user_info/${userId}/change_email`, "PUT", {
      app_group_id: appGroupId,
      new_email: newEmailAddress,
    });
  }
);
